(() => {
  if (window.__bpUploaderV5Loaded) return;
  window.__bpUploaderV5Loaded = true;

  const VALID_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'webp', 'pdf', 'tif', 'tiff', 'psd', 'ai', 'eps', 'zip']);
  const MAX_BYTES = 20000000;
  const busyForms = new WeakMap();
  const findWidget = (form) => document.querySelector('[data-bp-upload][data-bp-form-id="' + CSS.escape(form.id) + '"]');
  const readable = (bytes) => (bytes / 1000000).toFixed(1).replace('.', ',') + ' MB';
  const update = (root, message, error = false) => {
    const label = root.querySelector('[data-bp-status]');
    if (label) { label.textContent = message; label.dataset.error = String(error); }
  };
  const progress = (root, percentage, visible) => {
    const el = root.querySelector('[data-bp-progress]');
    const pct = root.querySelector('[data-bp-percent]');
    if (!el) return;
    el.hidden = !visible;
    el.value = percentage;
    if (pct) { pct.hidden = !visible; pct.textContent = percentage + ' %'; }
  };
  const validate = (root, file, required) => {
    if (!file) return required ? 'Bitte zuerst eine Druckdatei auswählen.' : '';
    if (!file.size) return 'Die gewählte Datei ist leer. Bitte eine andere Datei auswählen.';
    const ext = file.name.split('.').pop().toLowerCase();
    if (!VALID_EXTENSIONS.has(ext)) return 'Dieses Dateiformat wird nicht unterstützt. Erlaubt: JPG, PNG, WEBP, PDF, TIFF, PSD, AI, EPS oder ZIP.';
    if (file.size > MAX_BYTES) return 'Die Datei ist zu groß (' + readable(file.size) + '). Erlaubt sind maximal 20 MB. Bitte die Datei verkleinern.';
    return '';
  };
  const rootUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-bp-upload-file]')) return;
    const root = input.closest('[data-bp-upload]');
    if (!root) return;
    const file = input.files?.[0] || null;
    progress(root, 0, false);
    const error = validate(root, file, root.dataset.bpRequired === 'true');
    if (error) update(root, error, true);
    else if (file) update(root, 'Bereit: ' + file.name + ' (' + readable(file.size) + '). Die Datei wird beim Hinzufuegen zum Warenkorb übertragen.');
    else update(root, 'Bitte eine Datei auswählen.');
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    const widget = findWidget(form);
    if (!widget) return;
    const input = widget.querySelector('[data-bp-upload-file]');
    if (!input) return;
    const file = input.files?.[0] || null;
    const required = widget.dataset.bpRequired === 'true';
    const detailsRequired = widget.dataset.bpDetailsRequired === 'true';
    const container = widget.closest('.bp-buyer-fields');
    const textFields = container ? [...container.querySelectorAll('textarea, input[type="text"]')] : [];
    if (!file && !required && detailsRequired && !textFields.some(field => field.value.trim())) {
      event.preventDefault();
      event.stopImmediatePropagation();
      update(widget, 'Bitte mindestens einen Wunschtext oder eine Druckdatei angeben.', true);
      (textFields[0] || input).focus();
      return;
    }
    if (!file && !required) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const error = validate(widget, file, required);
    if (error) { update(widget, error, true); input.focus(); return; }
    if (!form.reportValidity() || form.dataset.bpSubmitting === 'true') return;
    form.dataset.bpSubmitting = 'true';
    form.enctype = 'multipart/form-data';
    form.encoding = 'multipart/form-data';
    [...form.querySelectorAll('button[type="submit"],input[type="submit"]')].forEach(button => { button.disabled = true; });
    const cancel = widget.querySelector('[data-bp-cancel]');
    if (cancel) cancel.hidden = true;
    progress(widget, 0, false);
    update(widget, 'Druckdatei wird mit dem Artikel übertragen. Bitte warten und die Seite nicht schließen.');
    HTMLFormElement.prototype.submit.call(form);
  }, true);
})();
